module.exports = __webpack_public_path__ + "static/media/Vitality.31ad69ab.png";